import type { ComponentProps } from 'react';
import {
  UserCircleIcon,
  ShieldCheckIcon,
  DocumentTextIcon,
  BanknotesIcon,
  DocumentDuplicateIcon,
  StarIcon,
  TrophyIcon,
  CurrencyEuroIcon,
  ArrowTrendingUpIcon,
  RocketLaunchIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';

const ICON_MAP: Record<string, React.ComponentType<ComponentProps<'svg'>>> = {
  UserCircleIcon,
  ShieldCheckIcon,
  DocumentTextIcon,
  BanknotesIcon,
  DocumentDuplicateIcon,
  StarIcon,
  TrophyIcon,
  CurrencyEuroIcon,
  ArrowTrendingUpIcon,
  RocketLaunchIcon,
};

interface BadgeIconProps extends ComponentProps<'svg'> {
  iconName: string;
}

export function BadgeIcon({ iconName, ...props }: BadgeIconProps) {
  const Icon = ICON_MAP[iconName] ?? SparklesIcon;
  return <Icon {...props} />;
}
